import { ModalController } from '@ionic/angular';
import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { OpenModalGuardService } from '../open-modal-guard/open-modal-guard.service';
import { CustomAlertComponent } from '../../components/custom-alert/custom-alert.component';

@Injectable({
  providedIn: 'root'
})
export class FunnelGuardService implements CanDeactivate<any> {

  navigateAwaySelection$: Subject<boolean> = new Subject<boolean>();
  serviceCreated = false;

  constructor(
    private modalController: ModalController,
    private openModalGuardService: OpenModalGuardService
  ) { }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.openModalGuardService.modalOpen) {
      return false;
    } else if (this.serviceCreated) {
      return true;
    } else {
      this.presentAlertConfirm();
      return this.navigateAwaySelection$;
    }
  }

  async presentAlertConfirm() {
    this.openModalGuardService.setModalOpen(true);
    const alert = await this.modalController.create({
      component: CustomAlertComponent,
      cssClass: 'custom-alert-small',
      componentProps: {
        icon: 'alerta',
        title: `No te vayas`,
        subtitle : 'Aún no has solicitado el servicio ¿Deseas continuar?',
        buttons: [
          {
            text: 'Cancelar servicio',
            fill: 'clear',
            color: 'danger',
            action: 'cancel'
          },
          {
            text: 'Continuar',
            fill: 'solid',
            color: 'primary',
            action: 'continuar'
          },
        ]
      },
      backdropDismiss: false
    });
    alert.onDidDismiss().then(data => {
      this.openModalGuardService.setModalOpen(false);
      if (data.data.action === 'cancel') {
        this.navigateAwaySelection$.next(true);
      }
      if (data.data.action === 'continuar') {
        this.navigateAwaySelection$.next(false);
      }

    });
    return await alert.present();
  }
}
